// src/components/ThemeToggleButton.js
import React from 'react';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';


const ThemeToggleButton = ({ toggleTheme }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Tooltip title={t('Toggle light/dark mode')}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        sx={{
          transition: 'transform 0.3s ease',
          '&:hover': { transform: 'rotate(20deg)' },
        }}
      >
        {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
